import { render, staticRenderFns } from "./SendIndications.vue?vue&type=template&id=6a688dc2&scoped=true&"
import script from "./SendIndications.vue?vue&type=script&lang=js&"
export * from "./SendIndications.vue?vue&type=script&lang=js&"
import style0 from "./SendIndications.vue?vue&type=style&index=0&id=6a688dc2&scoped=true&lang=css&"
import style1 from "./SendIndications.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a688dc2",
  null
  
)

export default component.exports